import React, {useState, useEffect} from 'react'
import Modal from '../Modal'
import {OkButton, CancelButton} from '../ui/components/Buttons'

const ModalActionAndTrigger = ({
  modalId,
  modalContent,
  action,
  trigger,
  triggerClassNames,
  additionalClasses,
  header,
}) => {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (!open) return
    const onKeyDown = (e) => {
      if (e.key === 'Escape') setOpen(false)
    }
    document.addEventListener('keydown', onKeyDown)
    return () => document.removeEventListener('keydown', onKeyDown)
  }, [open])

  const onOk = (e) => {
    setOpen(false)
    if (action) action(e)
  }

  return (
    <>
      <a
        className={`cursor-pointer${
          typeof triggerClassNames !== 'undefined'
            ? ` ${triggerClassNames}`
            : ``
        }${
          typeof additionalClasses !== 'undefined'
            ? ` ${additionalClasses}`
            : ``
        }`}
        onClick={() => setOpen(true)}
      >
        {trigger}
      </a>
      <Modal
        header={header}
        modalId={modalId}
        modalContent={modalContent}
        open={open}
        onClose={() => setOpen(false)}
      >
        <CancelButton action={() => setOpen(false)} />
        <OkButton action={onOk} />
      </Modal>
    </>
  )
}

export default ModalActionAndTrigger
